import { useState } from 'react';
import globalStyles from './global.module.css';
import ApiClient from './utils/apiClient';
import DownloadIcon from './img/download-minimalistic-svgrepo-com.svg';
import type { DisplaySchedule } from './utils/scheduleHelpers';

interface ExportPdfButtonProps {
    timeRange: { start: unknown; end: unknown };
    schedule?: DisplaySchedule | null;
    studentsList?: readonly unknown[] | null;
    selectedClass?: { name?: string | null; room?: string | null } | null;
}

function ExportPdfButton({ timeRange, schedule, studentsList, selectedClass }: ExportPdfButtonProps) {
    const [loading, setLoading] = useState(false);

    const handleExport = async () => {
        if (!schedule) {
            alert('Kein Stundenplan zum Exportieren vorhanden.');
            return;
        }

        setLoading(true);

        console.log("handleExport: schedule:", schedule);

        const scheduleWithNames = schedule;

        console.log("scheduleWithNames:", scheduleWithNames);

        try {
            const response = await ApiClient.post('export-pdf-alternative', {
                    schedule: scheduleWithNames,
                    timeRange: {
                        start: timeRange.start,
                        end: timeRange.end
                    },
                    studentsList,
                    classInfo: selectedClass ? {
                        name: selectedClass.name,
                        room: selectedClass.room
                    } : null
                }
            );
            // ApiClient wirft bei !ok - kein manueller Check nötig

            // Empfange die PDF als Blob
            const blob = await response.blob();

            // Erstelle einen Download Link
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'stundenplan.pdf';
            document.body.appendChild(a);
            a.click();

            // Cleanup
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);

        } catch (error) {
            console.error('Fehler beim PDF Export:', error);
            alert('Fehler beim PDF Export.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <button
            className={`${globalStyles.labeledButton} ${loading ? globalStyles.loading : ''}`}
            onClick={handleExport}
            disabled={loading || !schedule || !studentsList}
            title={loading ? 'PDF wird erstellt …' : 'Stundenplan als PDF herunterladen'}
        >
            <img
                src={DownloadIcon}
                alt=""
                aria-hidden="true"
                className={globalStyles.labeledButtonIcon}
            />
            <span>{loading ? 'PDF wird erstellt …' : 'PDF herunterladen'}</span>
        </button>
    );
}

export default ExportPdfButton;
